<template>
    <b-card no-body class="production-line-wrapper">
<!--        v-b-toggle="`collapse-linea-card-${linea.id}`"-->
        <b-card-header
            class="collapse-card-header production-line-header"
            :class="isProductionLineOpen ? null : 'collapsed'"
            :aria-expanded="isProductionLineOpen ? 'true' : 'false'"
            :aria-controls="`collapse-production-line-card-${productionLine.id}`"
            @click="handleCollapseClick()"
        >
            <span class="name">{{ productionLine.name }}</span>
        </b-card-header>
        <b-collapse :id="`collapse-production-line-card-${productionLine.id}`" v-model="isProductionLineOpen" >
            <b-card-body >
                <div class="stations-list">
                    <Station
                        :ref="`station-${station.id}`"
                        v-for="station in productionLine.stations"
                        :key="station.id"
                        :station="station"
                        :productionLineCollapseId="`collapse-production-line-card-${productionLine.id}`"
                    ></Station>
                </div>
                <div class="machine-monitorization">
                    <MachineMonitorizationGraph
                        v-for="activeMachine in activeMachines"
                        :key="activeMachine.id"
                        :ref="`machine_${activeMachine.id}`"
                        :machineId="Number(activeMachine.id)"
                    ></MachineMonitorizationGraph>
                </div>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';

import axios from "axios";
import MachineMonitorizationGraph from "../../common/components/MachineMonitorizationGraph";
import Station from "./Station";
import {showWarning} from "../../common/store/utils";
export default {
    name: 'ProductionLine',
    components:{
        Station,
        MachineMonitorizationGraph
    },
    props:{
        productionLine: Object
    },
    data(){
        return {
            KPIDataInterval: null,
            retrievingData: false,
            errorCount: 0,
            maxErrorCount: 10
        }
    },
    methods:{
        ...mapActions('monitorization',['changeCollapsableProductionLineState', 'updateActiveMachine', 'deleteActiveMachine']),

        //Hace que se cierren los demas collapse al abrir este
        handleCollapseClick(){
            this.changeCollapsableProductionLineState(this.productionLine.id)
        },
        initKPIDataInterval(){
            var self = this;
            //Datos generales de los equipos activos
            self.KPIDataInterval = setInterval(function(){
                self.obtainKPIData()
            },10000)
            //Peso de los equipos
        },
        obtainKPIData() {
            let self = this;
            if(self.retrievingData) return; //Si la consulta anterior esta en proceso, no hacer otra
            if(self.activeMachines && self.activeMachines.length){
                self.retrievingData = true;
                console.log('Request',  self.activeMachines)
                self.activeMachines.map(m => m.id).forEach((id, i) => {

                    axios.get(`/api/machine/get-kpi/${id}`)
                        .then(res => {
                            self.errorCount = 0;
                            if(res.data) self.updateActiveMachine( {id:id, ...res.data });
                            else showWarning(`Error al obtener informacion del equipo (id ${id}) ${ errorExists? `\nError: ${res.data.error}`:''}`, res);

                            self.retrievingData = false;
                        })
                        .catch(err => {
                            showWarning(err)
                            self.updateActiveMachine( {id:id, error: 'Timeout excedido' });
                            self.retrievingData = false;
                            // A mas errores, mas tiempo esperara entre intentos de actualizacion, hast llegar a 1 minuto
                            if(self.errorCount < self.maxErrorCount) self.errorCount++;
                            setTimeout(function(){ self.retrievingData = false;}, (((60/self.maxErrorCount) * self.errorCount)-3)*1000 )
                        })
                })
            }
        },
    },
    mounted(){
        // this.initKPIDataInterval()
    },
    watch:{
        // Al cerrarse la linea de produccion, dejan de actualizarse los datos y se cerran los equipos visualizados
        isProductionLineOpen(oldValue, newValue){
            let self = this;
            if(newValue) { // Si ahora mismo esta abierta, se cerrara, por lo que hay que eliminar las maquinas que se estan actualizando.
                clearInterval(self.KPIDataInterval);
                self.retrievingData = false;

                self.activeMachinesByProductionLine(self.productionLine?.id).forEach(m => {
                    self.deleteActiveMachine(m.id)
                })
            }else self.initKPIDataInterval()

        }
    },
    computed:{
        ...mapGetters('monitorization', ['productionLineCollapseStateById','activeMachinesByProductionLine']),
        isProductionLineOpen: {
            get: function() {
                return this.productionLineCollapseStateById(this.productionLine.id);
            },
            set: function() {}
        },
        // isProductionLineOpen: {
        //     get: function () {
        //         return
        //     },
        //     // setter
        //     set: function (newValue) {
        //         this.changeCollapsableProductionLineState(this.productionLine.id);
        //     }
        // },
        activeMachines(){
            return this.activeMachinesByProductionLine(this.productionLine.id)
        }
    }
}
</script>
